import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styled from 'styled-components';

import { Trans } from 'react-i18next';

import LoginForm from '../../forms/LoginForm';
import { Text } from '../../common';
import { AuthModal } from '../../modals';
import { toggleModal } from '../../../../modules/app/appActions';
import { cleanUpAuthErrors, resetPass } from '../../../../modules/auth/authActions';
import { authModalLayouts } from '../../../constants/modals';

import { DisplayFlexS } from '../../../../utils/stylesHelpers';
import { getThemeColor, getThemeSize } from '../../../../utils/theme';
import { withLanguageOnChange } from '../../../../utils/enhancers/withLanguageChange';
import LogoImg from '../../../assets/imgs/Logo.svg';

export const AdminLoginWrap = styled(DisplayFlexS)`
    height: 100%;
    margin-top: -70px;
`;

export const AdminLoginForm = styled.div`
    max-width: 600px;
    width: 100%;
    padding: 70px 50px 40px 50px;
    background-color: ${getThemeColor(['white'])} ;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25)
`;

export const AdminLoginTextS = styled(Text)`
    display: block;
    font-size: ${getThemeSize(['headers', 'secondary'])}; 
    margin-bottom: 25px;
`;

export const AdminLoginLogo = styled.img`
    max-width: 274px;
    width: 100%;
    margin-bottom: 35px;
`;

const TextBtnS = styled(Text)`
  display:block;
  color: ${getThemeColor(['greyViolet'])};
  cursor: pointer;
`;

const AdminLogin = ({ toggleModal }) => (
    <AdminLoginWrap aItems="center" justify="center" direction="column">
        <AdminLoginLogo src={ LogoImg } />
        <AdminLoginForm>
            <AdminLoginTextS color="violet">
                <Trans i18nKey="modals.auth.login.header" />
            </AdminLoginTextS>
            <LoginForm isAdmin />
            <TextBtnS onClick={() => toggleModal({ layout: authModalLayouts.resetPass, open: true })}>
                <Trans i18nKey="modals.auth.login.forgotPass" />
            </TextBtnS>
            <AuthModal />
        </AdminLoginForm>
    </AdminLoginWrap>
);

export default compose(
    connect(() => ({}),
        { toggleModal, resetPass, cleanUpAuthErrors }),
    withLanguageOnChange
)(AdminLogin)
